import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormItem } from '@/components';
import { Select } from '@/ui';
import { IManager } from '@/models/admins.model';
import { PartnerFormFieldsNames } from '../../helpers/types';
import { useCategoryManagersOptions } from '../../hooks';

interface ICategoryManagerField {
  label: string;
  currentManager?: IManager | null;
}

const CategoryManagerField = ({ label, currentManager }: ICategoryManagerField) => {
  const { t } = useTranslation(['partners']);
  const options = useCategoryManagersOptions(currentManager);

  return (
    <FormItem name={PartnerFormFieldsNames.CATEGORY_MANAGER_ID} label={label}>
      <Select options={options} placeholder={t('partners_category_manager_placeholder')} allowClear />
    </FormItem>
  );
};

export default CategoryManagerField;
